import { Button } from "@/components/ui/button"
import { Lock } from "lucide-react"
import { motion } from "framer-motion"
import { useNavigate } from "react-router-dom"
import { cn } from "@/lib/utils"

export default function WelcomePage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-indigo-950 overflow-hidden relative flex items-center justify-center p-6">
      {/* Фоновые декоративные свечения */}
      <div className="absolute inset-0 bg-[radial-gradient(at_50%_30%,rgba(168,85,247,0.08)_0%,transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(at_20%_70%,rgba(129,140,248,0.06)_0%,transparent_60%)]" />

      <motion.div
        initial={{ opacity: 0, y: 60 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.1, type: "spring", stiffness: 65, damping: 14 }}
        className="text-center max-w-5xl relative z-10"
      >
        {/* ЛОГОТИП — увеличен */}
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.2, duration: 1, type: "spring" }}
          className="mb-12 flex justify-center"
        >
          <img
            src="/images/logo.png"
            alt="ОРВ ВСКС"
            className="w-[420px] h-auto drop-shadow-2xl filter brightness-110"
            onError={(e) => {
              e.currentTarget.style.display = "none"
            }}
          />
        </motion.div>

        {/* Заголовок — одинаковый шрифт и цвет */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.9 }}
          className="text-6xl md:text-7xl lg:text-8xl font-bold text-white tracking-tighter leading-none mb-6"
        >
          Отдел регионального
          <br />
          взаимодействия
        </motion.h1>

        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.85, duration: 0.8 }}
          className="text-2xl md:text-3xl text-purple-200/90 font-light tracking-wide mb-16"
        >
          Всероссийского студенческого корпуса спасателей
        </motion.p>

        {/* Большая стеклянная кнопка */}
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 1.2, duration: 0.7 }}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
        >
          <Button
            onClick={() => navigate("/login")}
            className={cn(
              "group relative overflow-hidden",
              "bg-white/10 backdrop-blur-2xl border border-white/25 hover:border-white/40",
              "hover:bg-white/15",
              "text-white font-semibold text-3xl px-24 py-10 rounded-3xl",
              "shadow-2xl shadow-purple-950/60 transition-all duration-300",
              "flex items-center gap-5 mx-auto min-w-[380px]"
            )}
          >
            <Lock className="h-10 w-10 transition-transform group-hover:-rotate-12" />
            <span>Войти в систему</span>
          </Button>
        </motion.div>

        {/* Подвал */}
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.6 }}
          className="mt-20 text-purple-400/60 text-sm tracking-widest"
        >
          © 2025 ОРВ ВСКС • Закрытая корпоративная система
        </motion.p>
      </motion.div>

      {/* Декоративные фоновые блики */}
      <div className="absolute top-16 left-16 w-[600px] h-[600px] bg-purple-500/10 rounded-full blur-[140px]" />
      <div className="absolute bottom-12 right-12 w-[700px] h-[700px] bg-indigo-500/10 rounded-full blur-[160px]" />
    </div>
  )
}